export default "/_next/static/images/img1-2730edeafab02ea088d6cd2b537f0b3b.png";